// In-memory only: the bearer token `authMiddleware` attaches to every AppSync
// request lives in JS heap, never localStorage, so it cannot be copied out of
// DevTools and replayed by a script. Re-seeded by FederatedAuth on each login.
let jwtToken: string | null = null;

function isTokenExpired(token: string): boolean {
  try {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(base64));
    // No numeric `exp` means no valid expiry: treat as expired, never as live.
    if (typeof payload.exp !== 'number') {
      return true;
    }
    // JWT `exp` is epoch seconds (RFC 7519); Date.now() is milliseconds.
    return payload.exp * 1000 < Date.now();
  } catch (e) {
    return true;
  }
}

export function getJwtToken(): string | null {
  if (!jwtToken || isTokenExpired(jwtToken)) {
    return null;
  }
  return jwtToken;
}

export function setJwtToken(token: string): void {
  jwtToken = token;
}

export function removeJwtToken(): void {
  jwtToken = null;
}
